package fyi.moko.hotpl.ui.detail

import fyi.moko.hotpl.domain.model.Visit

/** A visit photo with the day it belongs to, so the strip can label it. */
internal data class DatedVisitPhoto(
    val visitId: String,
    val fileName: String,
    val visitedAt: Long,
)

/**
 * 이 가게에서 먹은 것들, 최근 방문부터.
 *
 * 사진이 어디에 **속하는지**는 그대로다 — 음식은 여전히 그날 방문의 기록이고, 가게 갤러리로
 * 올라오지 않는다([fyi.moko.hotpl.domain.model.PhotoKind] 참고). 바뀐 건 상세 화면이 무엇을
 * **먼저 보여주는지**다: 리뷰어가 이 페이지를 다시 여는 이유는 "여기가 어떻게 생겼더라"가
 * 아니라 "그때 뭘 먹었더라, 그걸 또 먹으러 갈까"이기 때문에, 방문 기록을 스크롤해 내려가야
 * 나오던 음식 사진을 위로 끌어올린다.
 *
 * [limit]으로 자르는 이유는 이 줄이 요약이기 때문이다 — 전체 이력은 아래 방문 카드에 그대로
 * 남아 있고, 여기서 답해야 하는 건 "최근에 뭘 먹었나" 한 가지다.
 */
internal fun whatYouAtePhotos(visits: List<Visit>, limit: Int = 12): List<DatedVisitPhoto> =
    visits
        .asSequence()
        .filterNot { it.isDeleted }
        .sortedByDescending { it.visitedAt }
        .flatMap { visit ->
            visit.photos.asSequence()
                .map { it.fileName }
                .filter { it.isNotBlank() }
                .map { DatedVisitPhoto(visitId = visit.id, fileName = it, visitedAt = visit.visitedAt) }
        }
        .distinctBy { it.fileName }
        .take(limit)
        .toList()
